import { render, staticRenderFns } from "./Prijemnica.vue?vue&type=template&id=5d5a6c52&scoped=true&"
import script from "./Prijemnica.vue?vue&type=script&lang=ts&"
export * from "./Prijemnica.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a6c52",
  null
  
)

export default component.exports